export const CHILD_SUPPORT_TEMPLATE_CONTAINER_TAG_NAME = 'child-support-template-container';
